export const ORGANIZATION_TYPE_CLUB: number = 1;
export const ORGANIZATION_TYPE_BUREAU: number = 2;
